<script setup>
/**
 * "From your sign-up form" (XN-4561, XN-4680): what the person answered when
 * they registered, as the staff record shows it, and read-only — the agency
 * changes these. The page leaves the whole block out when nothing was
 * answered: no heading, no card, no line.
 */
defineProps({
  // [{ question, answer }], in the form's order, answered ones only.
  answers: { type: Array, required: true },
  messageWho: { type: String, required: true },
});
</script>

<template>
  <section data-testid="details-card-sign-up">
    <div class="pdet-answers__sh"><h2>From your sign-up form</h2><i class="pdet-answers__ln" /></div>
    <dl class="pdet-answers__card">
      <div v-for="(row, index) in answers" :key="index" class="pdet-answers__row">
        <dt>{{ row.question }}</dt>
        <dd>{{ row.answer }}</dd>
      </div>
    </dl>
    <p class="pdet-answers__after">To change one of these, message {{ messageWho }}.</p>
  </section>
</template>

<style scoped>
/* Measurements from the prototype's profile() sign-up card, build 30 Sep 12:40. */
.pdet-answers__sh { display: flex; align-items: baseline; gap: 12px; margin: 34px 0 14px; }
.pdet-answers__sh h2 { margin: 0; font-size: 13px; font-weight: 600; letter-spacing: 0.1em; text-transform: uppercase; color: var(--xl-color-outline-variant); }
.pdet-answers__ln { flex: 1; height: 1px; background: var(--xl-color-border); }
.pdet-answers__card {
  padding: 8px 22px;
  margin: 0 0 14px;
  background: #fff;
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-lg);
  box-shadow: var(--xl-shadow-1);
}
.pdet-answers__row { display: flex; align-items: center; gap: 14px; padding: 15px 0; border-bottom: 1px solid var(--xl-color-border-subtle); }
.pdet-answers__row:last-child { border-bottom: 0; }
.pdet-answers__row dt { width: 200px; flex: 0 0 200px; font-size: 14px; color: var(--xl-color-outline); }
.pdet-answers__row dd { margin: 0; flex: 1; min-width: 0; font-weight: 500; overflow-wrap: anywhere; }
.pdet-answers__after { margin: 12px 0 0; font-size: 13px; color: var(--xl-color-outline); }
@media (max-width: 480px) {
  .pdet-answers__card { padding: 4px 14px; }
  .pdet-answers__row { flex-direction: column; align-items: flex-start; gap: 4px; }
  .pdet-answers__row dt { width: auto; flex: none; }
}
</style>
